module.exports = __webpack_public_path__ + "img/g.4207407e.png";